import { render, staticRenderFns } from "./shellOrderLists.vue?vue&type=template&id=7b354ce6&scoped=true&"
import script from "./shellOrderLists.vue?vue&type=script&lang=js&"
export * from "./shellOrderLists.vue?vue&type=script&lang=js&"
import style0 from "./shellOrderLists.vue?vue&type=style&index=0&id=7b354ce6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b354ce6",
  null
  
)

export default component.exports